export default "__VITE_ASSET__mk7vBwso__"